import { Link2 } from 'lucide-react';
import { PageHeader } from '../components/ui/PageHeader';
import { ComingSoon } from '../components/ui/ComingSoon';

export function LinkExplorerPage() {
  return (
    <>
      <PageHeader
        icon={Link2}
        title="Link Explorer"
        description="Reverse-lookup which pins link to a domain or URL."
      />
      <ComingSoon what="Link Explorer UI" />
    </>
  );
}
